export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/solution.62c55513.svg","height":203,"width":320,"blurWidth":0,"blurHeight":0};